import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Bell,
  BookOpen,
  GraduationCap,
  Mail,
  Megaphone,
  Pencil,
  Sparkles,
  Star,
} from "lucide-react";
import comingSoonLogo from "../../../Images/comingSoon.png";

export const ComingSoonPage = ({ screenName = "Current Affairs", subtitle }) => {
  const navigate = useNavigate();
  const subtitleText =
    subtitle || "We are working hard to bring something amazing for you.";
  const [beforeAmazing, ...afterAmazing] = subtitleText.split("amazing");
  const infoDescText = `We'll notify you as soon as ${screenName} is live.`;

  return (
    <div className="min-h-screen overflow-hidden bg-[#FBF8FF] text-[#281253] top-0">
      <main className="relative mx-auto flex max-w-md flex-col items-center px-5 pb-10 pt-0 lg:grid lg:min-h-[calc(100vh-5rem)] lg:max-w-6xl lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-12 lg:px-10 lg:py-2">
        <section className="relative h-[390px] w-full lg:h-[560px]">
          <div className="pointer-events-none absolute left-7 top-10 grid grid-cols-4 gap-2 opacity-50 lg:left-16 lg:top-24">
            {Array.from({ length: 12 }).map((_, index) => (
              <span key={index} className="h-2 w-2 rounded-full bg-[#D8C9EC]" />
            ))}
          </div>

          <Pencil className="pointer-events-none absolute left-6 top-48 z-[2] h-16 w-16 -rotate-12 text-[#D8C9EC] lg:left-12 lg:top-64 lg:h-20 lg:w-20" />
          <BookOpen className="pointer-events-none absolute right-3 top-48 z-[2] h-16 w-16 rotate-3 text-[#D8C9EC] lg:right-10 lg:top-56 lg:h-20 lg:w-20" />
          <Star className="pointer-events-none absolute right-24 top-16 z-[2] h-5 w-5 text-[#C9B4E7] lg:right-36 lg:top-20" />
          <Sparkles className="pointer-events-none absolute right-12 top-28 z-[2] h-5 w-5 text-[#C9B4E7] lg:right-20 lg:top-36" />
          <Sparkles className="pointer-events-none absolute left-8 top-48 z-[2] h-5 w-5 text-[#C9B4E7] lg:left-10 lg:top-68" />

          <div className="absolute left-1/2 top-0 h-72 w-72 -translate-x-1/2 rounded-full bg-purple-100 lg:top-10 lg:h-[28rem] lg:w-[28rem]" />
          <img
            src={comingSoonLogo}
            alt={`${screenName} coming soon`}
            className="relative z-10 mx-auto h-[400px] w-[100%] max-w-none object-contain drop-shadow-[0_16px_24px_rgba(67,28,116,0.14)] lg:h-[560px] lg:w-full"
          />
        </section>

        <section className="-mt-4 flex w-full flex-col items-center text-center lg:mt-10">
          <div className="relative flex flex-col items-center justify-center">
            <div className="absolute -left-16 top-12 flex h-10 w-10 flex-col items-end justify-center gap-4 lg:-left-20">
              <span className="h-1 w-5 rotate-45 rounded-full bg-[#B88CE7]" />
              <span className="h-1 w-5 rounded-full bg-[#B88CE7]" />
              <span className="h-1 w-5 -rotate-45 rounded-full bg-[#B88CE7]" />
            </div>
            <div className="absolute -right-16 top-12 flex h-10 w-10 flex-col items-start justify-center gap-4 lg:-right-20">
              <span className="h-1 w-5 -rotate-45 rounded-full bg-[#B88CE7]" />
              <span className="h-1 w-5 rounded-full bg-[#B88CE7]" />
              <span className="h-1 w-5 rotate-45 rounded-full bg-[#B88CE7]" />
            </div>
            <h1 className="text-[40px] font-black leading-[48px] text-[#281253] lg:text-[64px] lg:leading-[72px]">
              COMING
            </h1>
            <h2 className="text-[40px] font-black leading-[48px] text-[#FF8A00] lg:text-[64px] lg:leading-[72px]">
              SOON!
            </h2>
          </div>

          <div className="mt-5 flex w-full items-center justify-center gap-4 text-[#D7C7F2]">
            <span className="h-px w-20 bg-[#E5DDF3] lg:w-28" />
            <GraduationCap className="h-7 w-7 fill-[#D7C7F2]" />
            <span className="h-px w-20 bg-[#E5DDF3] lg:w-28" />
          </div>

          <p className="mt-5 max-w-xs whitespace-pre-line text-center text-md font-sm leading-8 text-[#6E6280] lg:max-w-md lg:text-2xl lg:leading-9">
            {/* {beforeAmazing}
            {subtitleText.includes("amazing") && (
              <span className="font-extrabold text-[#5F22B8]">amazing</span>
            )} */}
            {subtitleText.includes("amazing")
              ? afterAmazing.join("amazing")
              : subtitleText}
          </p>

          <div className="relative mt-8 flex w-full items-center rounded-3xl bg-[#F2EAF7] px-5 py-4 shadow-[0_4px_14px_rgba(40,18,83,0.06)] lg:max-w-lg lg:px-6 lg:py-5">
            <div className="flex h-[58px] w-[58px] shrink-0 items-center justify-center rounded-full bg-[#E8DDF3] text-[#281253] lg:h-16 lg:w-16">
              <Megaphone className="h-6 w-6 lg:h-7 lg:w-7" />
            </div>
            <div className="ml-4 min-w-0 flex-1 text-left">
              <h4 className="text-lg font-extrabold text-[#281253] lg:text-xl">
                Stay Tuned!
              </h4>
              <p className="mt-1 text-sm leading-5 text-[#7A6D8C] lg:text-base lg:leading-6">
                {infoDescText}
              </p>
            </div>
            <Mail className="h-6 w-6 shrink-0 text-[#C4B5D3]" />
            <Bell className="absolute right-2 top-8 h-5 w-5 fill-[#B99AE7] text-[#B99AE7] lg:right-4 lg:top-8" />
          </div>

          <button
            type="button"
            onClick={() => navigate("/dash/home")}
            className="mt-8 flex w-full items-center justify-center gap-3 rounded-full bg-gradient-to-r from-[#6424C5] to-[#FF8A00] px-6 py-4 text-lg font-extrabold uppercase tracking-wide text-white shadow-[0_10px_22px_rgba(123,46,255,0.22)] lg:max-w-lg"
          >
            <Bell className="h-6 w-6" />
            Notify Me
          </button>
        </section>
      </main>
    </div>
  );
};

const CurrentAffairs = () => (
  <ComingSoonPage
    screenName="Current Affairs"
    subtitle={
      "Stay updated with the latest national & international news, government schemes, economy, science, sports and exam updates - all in one place"
    }
   
  />
);

export default CurrentAffairs;
